if(document.querySelector('.variations-name')) {
    const data = JSON.parse(document.querySelector('form.variations_form').getAttribute('data-product_variations'));
    let atrrKey = '';
    let attrValue = [];
    let price = document.querySelector('.summary > .price');
    let statePrice = price.cloneNode(true);

    const updatesAttributesDOM = () => {
        let variations = document.querySelectorAll('.variations-name');
        variations.forEach((elem) => {
            let variationsName = elem.getAttribute('data-name');
            let attribut = 'attribute_' + variationsName;
            data.map((item)=> {
                if(item.attributes[attribut].length > 0) {
                    let getAllOption = `button[data-name="${item.attributes[attribut]}"]`;
                    document.querySelector(getAllOption).classList.add('enabled');
                }
            });
        });
        setTimeout(watchdisabledBtnAddToCart,300);
    }

    const setAditionalImg = (additionalImg) => {
        let oldImg = document.querySelectorAll('.woocommerce-product-gallery__image');
        let parentElem = document.querySelector('.woocommerce-product-gallery__wrapper');
        oldImg.forEach((item, index) => {
            if(index !== 0) {
                item.remove();
            }
        });
        additionalImg.forEach((item) => {
            const wrapper= document.createElement('div');
            wrapper.innerHTML= item;
            const nodeElem = wrapper.firstChild;
            parentElem.append(nodeElem);
        });
        $('.woocommerce-product-gallery').removeData("flexslider");
        document.querySelector('.woocommerce-product-gallery__thumbnails-wrapper').remove();
        $( '.woocommerce-product-gallery' ).each( function() {
            $( this ).wc_product_gallery();
        } );
    }
    
    const resetEnableAllOptionAtr = () => {
        let variationsName = '.variations-name.' + atrrKey.split('_').splice(1).join('_') + ' .variation-option-btn';
        document.querySelectorAll(variationsName).forEach((item) => {
            let getAttrName = item.getAttribute('data-name');
                if(!attrValue.includes(getAttrName) && !attrValue.includes('')) {
                    item.classList.remove('enabled');
                    item.disabled = true;
                } else {
                    item.classList.add('enabled');
                    item.disabled = false;
                }
        });
    }

    const changeAttributes = (optionBtn, attributePaName) => {
        let optionName = optionBtn.getAttribute('data-name');
        data.map((item) => {
                if(item.attributes[attributePaName] === optionName) {
                Object.entries(item.attributes).forEach(([key, value]) => {
                        if(attributePaName !== key) {
                            atrrKey = key;
                            attrValue.push(value);
                        }
                });
                if(item.additional_img) {
                    setAditionalImg(item.additional_img);
                }
            };
        });
        resetEnableAllOptionAtr();
    }

    const changePrice = () => {
        const variationPrice = document.querySelector('.woocommerce-variation-price > .price');
        if(variationPrice !== null) {
            price.replaceChildren();
            price.append(variationPrice);
        }
    }

    const watchdisabledBtnAddToCart = ()=> {
        if(document.querySelector('body').classList.contains('single-product') && document.querySelector('.single_add_to_cart_button')) {
            const btn = document.querySelector('.single_add_to_cart_button');
            if(document.querySelector('.single_add_to_cart_button').classList.contains('disabled')) {
                btn.disabled = true;
            } else {
                btn.disabled = false;
            }
        }
    };

    const resetVariationPrise = () =>  {
        price.replaceChildren();
        price.append(statePrice);
    }

    const handleEventsVariations = () => { 
        let variations = document.querySelectorAll('.variations-name');
        variations.forEach((item) => {
            let variationsName = item.getAttribute('data-name');
            let formSelect = document.getElementById(variationsName);
            let options = item.querySelectorAll('.variation-option-btn');
            let attribut = 'attribute_' + variationsName;
            options.forEach((option, index) => {
                let optionName = option.getAttribute('data-fullname');
                let optionСhange = (e) => {
                    e.preventDefault();
                    attrValue = [];
                    if (option.classList.contains('enabled')) {
                        let optionIndex = `option[value="${option.getAttribute("data-name")}"]`;
                        formSelect.selectedIndex = formSelect.querySelector(optionIndex).index;
                        formSelect.dispatchEvent(new Event('change', { bubbles: true }));
                        item.querySelector('.option-selected').innerText = optionName;
                        changePrice();
                        option.classList.add('active');
                        options.forEach((option, key) => {
                            if (key !== index) {
                                option.classList.remove('active');
                            }
                        });
                    }
                    changeAttributes(option, attribut);
                    watchdisabledBtnAddToCart();
                }
                option.addEventListener('click', optionСhange);
            });
        });
        const removeActiveSelector = () => {
            variations.forEach((item) => {
                let options = item.querySelectorAll('.variation-option-btn');
                item.querySelector('.option-selected').innerText = '';
                options.forEach((option) => {
                    option.classList.remove('active');
                    option.disabled = false;
                });
            });
        }
        let resetBtn = document.querySelector('.reset_variations');
        const resetData = () => {
            updatesAttributesDOM();
            removeActiveSelector();
            resetVariationPrise();
            watchdisabledBtnAddToCart();
        }
        resetBtn.addEventListener('click', resetData);
    };

    window.addEventListener('DOMContentLoaded', updatesAttributesDOM);

    handleEventsVariations();
}